import {Apple, Play} from 'lucide-react';
import React, {useEffect, useState} from 'react';
import CivicPointsIconLogo from '../../../assets/icons/civicpoints_logo.svg';
import {REACT_APP_ENV} from "../../../config/runtime";

const EventDeepLinkPage: React.FC = () => {
    const iosLink = 'https://apps.apple.com/app/civicpoints/id6747657300';
    const androidLink = 'https://play.google.com/store/apps/details?id=com.idlemindtech.cityeg.prod&pcampaignid=web_share';
    const [showDownloadDialog, setShowDownloadDialog] = useState(false);

    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
    const isAndroid = /Android/.test(navigator.userAgent);

    const openAppWithFallback = () => {
        const timeoutMs = 2000;
        const start = Date.now();
        let appScheme = "civicapp://";

        if (REACT_APP_ENV === "dev") appScheme = "civicapp-dev://";

        if (!(isIOS || isAndroid)) {
            setShowDownloadDialog(true);
            return;
        }

        try {
            window.open(appScheme, "_self");
        } catch (e) {
            setShowDownloadDialog(true);
        }

        setTimeout(() => {
            const elapsed = Date.now() - start;
            if (elapsed < timeoutMs + 500) {
                setShowDownloadDialog(true);
                if (isAndroid) window.location.href = androidLink;
                if (isIOS) window.location.href = iosLink;
            }
        }, timeoutMs);
    };

    useEffect(() => {
        openAppWithFallback();
    }, []);

    const handleIOSDownload = () => window.open(iosLink, '_blank');
    const handleAndroidDownload = () => window.open(androidLink, '_blank');

    return (
        <div
            className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 dark:from-[#0d2721] dark:via-[#1a1a1a] dark:to-[#0d2721] p-4">
            <div className="w-full max-w-md">
                <div className="bg-white dark:bg-[#242424] rounded-2xl shadow-xl p-8 md:p-10">
                    <div className="flex justify-center mb-6">
                        <img src={CivicPointsIconLogo} alt="CivicPoints" className="h-20 w-auto"/>
                    </div>

                    <div className="text-center mb-8">
                        <h1 className="text-2xl md:text-3xl font-bold text-black dark:text-[#e5e5e5] mb-3">
                            {showDownloadDialog ? "Download CivicPoints" : "Opening CivicPoints App..."}
                        </h1>
                        <p className="text-base md:text-lg text-[#797979] dark:text-[#a0a0a0]">
                            {showDownloadDialog
                                ? "Join community activities, earn points, and redeem rewards"
                                : "Please wait while we try to open the app."}
                        </p>
                    </div>

                    {showDownloadDialog && (
                        <div className="space-y-4">
                            <button
                                onClick={handleIOSDownload}
                                className="w-full h-14 bg-black dark:bg-gray-800 text-white font-bold rounded-[30px] flex items-center justify-center gap-3 hover:bg-gray-800 dark:hover:bg-gray-700 transition"
                            >
                                <Apple className="w-6 h-6"/>
                                <span>Download for iOS</span>
                            </button>
                            <button
                                onClick={handleAndroidDownload}
                                className="w-full h-14 bg-[#00C49A] dark:bg-emerald-500 text-[#004231] dark:text-white font-bold rounded-[30px] flex items-center justify-center gap-3 hover:bg-[#00b38a] dark:hover:bg-emerald-600 transition"
                            >
                                <Play className="w-6 h-6"/>
                                <span>Download for Android</span>
                            </button>
                        </div>
                    )}

                    {!showDownloadDialog && (
                        <div className="flex justify-center mt-4">
                            <div
                                className="animate-spin h-8 w-8 border-4 border-[#00C49A] dark:border-emerald-500 border-t-transparent rounded-full"></div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default EventDeepLinkPage;
